import { Auth0OrganizationData } from '../models';

export function isPreProdOrg(org: Pick<Auth0OrganizationData, 'metadata'> | undefined): boolean {
  return org?.metadata?.app_preprod === 'true';
}
